import { Paper, Stack, Text, Button, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { UseFormReturnType } from '@mantine/form';
import { IconBook } from '@tabler/icons-react';
import { AssetBundleItem } from '@/API';
import { ExtensionManifestFormValues } from './types';
import { ExtensionDevGuideModal } from '../ExtensionDevGuideModal';
import { AssetBundleFileSelect } from './AssetBundleFileSelect';

interface CustomHtmlTemplateFormProps {
  form: UseFormReturnType<ExtensionManifestFormValues>;
  htmlFiles: string[];
  workspaceId: string;
  botProviderId: string;
  bundle: AssetBundleItem;
  onBundleUpdated?: (updatedBundle: AssetBundleItem) => void;
}

const ALLOWED_HTML_EXTENSIONS = ['.html', '.htm'];

export function CustomHtmlTemplateForm({
  form,
  htmlFiles,
  workspaceId,
  botProviderId,
  bundle,
  onBundleUpdated,
}: CustomHtmlTemplateFormProps) {
  const [guideOpened, { open: openGuide, close: closeGuide }] = useDisclosure(false);

  return (
    <Paper withBorder p="sm" radius="md">
      <Stack gap="sm">
        <Group justify="space-between" align="center">
          <Text fw={500} size="sm">
            自訂網頁入口設定
          </Text>
          <Button
            variant="subtle"
            color="indigo"
            size="compact-xs"
            leftSection={<IconBook size={14} />}
            onClick={openGuide}
          >
            查看通訊 API 與 HTML 範本
          </Button>
        </Group>
        <AssetBundleFileSelect
          label="HTML 入口檔案 (Entry File)"
          placeholder="選擇 HTML 檔"
          data={htmlFiles.length > 0 ? htmlFiles : ['index.html']}
          withAsterisk
          workspaceId={workspaceId}
          botProviderId={botProviderId}
          bundle={bundle}
          allowedExtensions={ALLOWED_HTML_EXTENSIONS}
          pickerTitle="挑選 HTML 入口檔案 (.html / .htm)"
          onBundleUpdated={onBundleUpdated}
          {...form.getInputProps('entryHtml')}
        />
        <Text size="xs" c="dimmed">
          將以沙盒 iframe 嵌入該網頁，並自動透過 postMessage 派發 cakechat:state-change 事件。
        </Text>
      </Stack>

      <ExtensionDevGuideModal
        opened={guideOpened}
        onClose={closeGuide}
        defaultTab="iframe"
      />
    </Paper>
  );
}
